import { getQueryParams } from 'utils/url';
import { authorizedGet, authorizedPost } from './baseApiService';
import { IReward, IRewardFilters, ReferralEvent, ReferralStats } from 'global/interfaces/reward';

const resource = 'rewards';

export async function getRewards(filters: IRewardFilters | null): Promise<IReward[]> {
  const coreFilters = filters as IRewardFilters;
  return await authorizedGet<IReward[]>(`${resource}?${getQueryParams(coreFilters)}`);
}

export async function sendRewards(): Promise<boolean> {
  return await authorizedPost<boolean>(`${resource}`, {});
}

export async function sendReferral(referralEvent: ReferralEvent): Promise<void> {
  return await authorizedPost<void>(`${resource}/referral`, referralEvent);
}

export async function getReferralStats(): Promise<ReferralStats> {
  return await authorizedGet<ReferralStats>(`${resource}/referral/stats`);
}
